import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { BsCheck2Square, BsSlashCircle } from "react-icons/bs";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";

const ViewDeliveryChallan = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [refresh, setRefresh] = useState(false);
  const [materialData, setMaterialData] = useState([]);
  const [hydrponicType, setHydrponicType] = useState();
  const [currentInventoryData, setCurrentInventoryData] = useState([]);
  const [totalCount, setTotalCount] = useState([]);

  let { id } = useParams();
  const navigate = useNavigate();

  const duplicateDC = () => {
    navigate(`/delivery-challan/new?duplicate=${id}`);
  };
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/deliveryChallan/getDcById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.dcStatus);
          setMaterialData(res?.data?.materialData?.materialList);
          setHydrponicType(res?.data?.materialData?.hydroponicType);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/materialPlanning/getAllMaterialList`)
      .then((res) => {
        if (res.status === 200) {
          setCurrentInventoryData(res?.data?.MaterialList);
          setTotalCount(res?.data?.consolidatedList);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  const handelDCAproval = () => {
    performRequest("PATCH", `/deliveryChallan/updateDc/${id}`, {
      isApproved: true,
      materialListData: materialData,
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "DC Approved successfully!");
          setRefresh(!refresh);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  const getPrice = (inStock, costperUnit, weight, unit) => {
    const weightNew = parseFloat(weight);

    // if weight is a valid number > 0 and unit is among the specified ones, calculate with weight
    if (
      (unit === "kg" ||
        unit === "grams" ||
        unit === "ltr" ||
        unit === "ml" ||
        unit === "mtr") &&
      !isNaN(weightNew) &&
      weightNew > 0
    ) {
      return weightNew * costperUnit * inStock;
    }

    // fallback if weight is missing or 0
    return costperUnit * inStock;
  };

  const totalCountArray = Array.isArray(totalCount)
    ? totalCount
    : Object.values(totalCount);

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Delivery Challan</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Delivery Challan</h2>
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Challan date</label>
                  <div className="w-100 col">
                    {(data?.challanDate || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Project</label>
                  <div className="w-100 col">
                    {(
                      data?.contactPersonName ||
                      data?.cusClientName ||
                      "N/A"
                    ).toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Country of supply
                  </label>
                  <div className="w-100 col">
                    {(data?.countryOfSupply || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Driver name</label>
                  <div className="w-100 col">
                    {(data?.driverName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Driver phone number
                  </label>
                  <div className="w-100 col">
                    {(data.driverPhoneNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Eway bill number
                  </label>
                  <div className="w-100 col">
                    {(data?.ewayBillNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )} */}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Lr number</label>
                  <div className="w-100 col">
                    {(data?.lrNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Place of supply
                  </label>
                  <div className="w-100 col">
                    {(data?.placeOfSupply || "N/A").toUpperCase()}
                  </div>
                </div>
              )} */}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Transport name
                  </label>
                  <div className="w-100 col">
                    {(data?.transportName || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Vehicle number
                  </label>
                  <div className="w-100 col">
                    {(data?.vehicleNumber || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Driver's DL</label>
                  <div className="w-100 col">
                    {data?.driverDL ? (
                      <LazyImageComponent
                        width="50%"
                        src={data?.driverDL}
                        alt={"driverDL"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Vehicle front</label>
                  <div className="w-100 col">
                    {data?.vehicleFront ? (
                      <LazyImageComponent
                        width="50%"
                        src={data?.vehicleFront}
                        alt={"vehicleFront"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Vehicle back</label>
                  <div className="w-100 col">
                    {data?.vehicleBack ? (
                      <LazyImageComponent
                        width="50%"
                        src={data?.vehicleBack}
                        alt={"vehicleBack"}
                      />
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Additional photos
                  </label>
                  <div className="w-100 col">
                    <div className="row">
                      {data?.additionalPhotos &&
                      data?.additionalPhotos.length > 0
                        ? data?.additionalPhotos.map((photo, index) => (
                            <div key={index} className="col-6 mb-2">
                              <LazyImageComponent
                                width="90%"
                                src={photo}
                                alt={`additionalPhoto-${index + 1}`}
                              />
                            </div>
                          ))
                        : "N/A"}
                    </div>
                  </div>
                </div>
              )}
              <hr></hr>
              {materialData && (
                <div className="col-lg-12 col-md-12">
                  <h2 className="mt-2">Material List : {hydrponicType}</h2>
                  <div className="table-responsive">
                    <table className="table table-vcenter w-100 border">
                      <thead>
                        <tr>
                          <th style={{ minWidth: "150px" }}>Sr/ HSN/ Image</th>
                          <th style={{ minWidth: "170px" }}>
                            ITEM /SKU/ Weight/ Formula
                          </th>
                          <th style={{ minWidth: "200px" }}>Specifications</th>
                          <th>In stock / Count / Price</th>
                          <th>Loading Time Photo</th>
                        </tr>
                      </thead>

                      <tbody>
                        {materialData
                          ?.filter((item) => item?.count)
                          .map((item, index) => {
                            const specialSkus = ["MAT-CEA-FLA-FOG-GRO-00042"];

                            const totalCount = specialSkus.includes(item?.sku)
                              ? item?.countGrow || 0
                              : (item?.countFlat || 0) + (item?.countGrow || 0);

                            return (
                              <tr
                                key={index}
                                // style={{
                                //   backgroundColor:
                                //     Number(item.count) >
                                //     Number(
                                //       currentInventoryData.find(inv => inv.sku === item.sku)?.inStock || 0
                                //     )
                                //       ? "#ffcccc"
                                //       : "transparent",
                                // }}

                                style={{
                                  backgroundColor: (() => {
                                    const inventoryStock = Number(
                                      currentInventoryData.find(
                                        (inv) => inv.sku === item.sku
                                      )?.inStock || 0
                                    );

                                    // Special case: Growbag SKU + hydrophonicsOly type
                                    if (
                                      item.sku ===
                                        "MAT-CEA-FLA-FOG-GRO-00042" &&
                                      hydrponicType === "hydroponicsOnly"
                                    ) {
                                      return Number(item.countGrow) >
                                        inventoryStock
                                        ? "#ffcccc"
                                        : "transparent";
                                    }

                                    // Default behavior
                                    return Number(item.count) > inventoryStock
                                      ? "#ffcccc"
                                      : "transparent";
                                  })(),
                                }}
                              >
                                {/* Column 1 */}
                                <td>
                                  <img
                                    src={item?.image}
                                    alt={item?.item}
                                    width="150"
                                    height="150"
                                    className="m-0 mt-1 mb-1"
                                    style={{ borderRadius: "8px" }}
                                  />
                                  <br />
                                  <span className="me-1">{index + 1}.</span>
                                  {item?.hsn && (
                                    <span className="fs-5">
                                      <b>HSN: {item?.hsn}</b>
                                    </span>
                                  )}
                                </td>

                                {/* Column 2 */}
                                <td>
                                  <span className="fs-5">{item?.item}</span>
                                  <br />
                                  <b>SKU : {item?.sku}</b>

                                  {item?.weight && (
                                    <>
                                      <br />
                                      <b>
                                        Weight : {item?.weight} {item?.proUnit}
                                      </b>
                                    </>
                                  )}

                                  {item?.formula && (
                                    <>
                                      <br />
                                      <b>Formula : {item?.formula}</b>
                                    </>
                                  )}

                                  {item?.flatFormul && (
                                    <>
                                      <br />
                                      <b>Formula : {item?.flatFormul}</b>
                                    </>
                                  )}

                                  {item?.mergeType && (
                                    <>
                                      <br />
                                      <b>Available in : {item?.mergeType}</b>
                                    </>
                                  )}

                                  {(item?.countFlat || item?.countGrow) && (
                                    <>
                                      <br />
                                      <b>
                                        Flatbed Count : {item?.countFlat || "0"}
                                        {item?.unit}
                                      </b>
                                      <br />
                                      <b>
                                        Growbags Count :{" "}
                                        {item?.countGrow || "0"}
                                        {item?.unit}
                                      </b>
                                      <hr className="p-0 m-1" />
                                      <b>
                                        Total Count : {totalCount}
                                        {item?.unit}
                                      </b>
                                    </>
                                  )}
                                </td>

                                {/* Column 3 */}
                                <td className="fs-5">
                                  {item?.specificationsNew?.length
                                    ? [
                                        ...new Map(
                                          item.specificationsNew
                                            .filter(
                                              (spec) =>
                                                (hydrponicType === "cea-nvph" &&
                                                  spec?.type === "cea") ||
                                                hydrponicType === spec?.type ||
                                                (hydrponicType ===
                                                  "hydroponicsOnly" &&
                                                  (spec?.type === "flatbed" ||
                                                    spec?.type === "growbags"))
                                            )
                                            .map((spec) => [
                                              spec?.specification,
                                              spec,
                                            ])
                                        ).values(),
                                      ].map((spec, i) => (
                                        <div key={i}>{spec?.specification}</div>
                                      ))
                                    : "N/A"}
                                  <br className="m-0 p-0"></br>
                                  {item?.brandName && (
                                    <p className="m-0 badge bg-green-lt">
                                      Brand Name: {item?.brandName}
                                    </p>
                                  )}

                                  {totalCountArray?.length > 0 && (
                                    <>
                                      <hr className="mb-1 mt-0 p-0"></hr>
                                      <h4 className="m-0 fw-bold">
                                        Total Stock For DC Approval :
                                      </h4>
                                      <div>
                                        <span className="fs-2">
                                          <b>
                                            {totalCountArray.find(
                                              (inv) => inv.sku === item.sku
                                            )?.totalRequired ?? 0}
                                            {totalCountArray.find(
                                              (inv) => inv.sku === item.sku
                                            )
                                              ? item?.unit
                                              : ""}
                                          </b>
                                        </span>
                                      </div>
                                    </>
                                  )}

                                  {/* <h4 className="m-0 fw-bold">
                                  Total Stock For DC Approval :
                                  </h4>
                                  <span className="fs-2">
                                    <b>
                                    {totalCountArray?.find(
                                      (inv) => inv.sku === item.sku
                                    )?.totalRequired ?? 0}
                                    {totalCountArray?.find(
                                      (inv) => inv.sku === item.sku
                                    )?.unit ?? 0}
                                    </b>
                                  </span> */}
                                </td>

                                {/* Column 4 */}
                                <td style={{ width: "120px" }}>
                                  <span className="fs-3">
                                    <b>
                                      Count :{" "}
                                      {["MAT-CEA-FLA-FOG-GRO-00042"].includes(
                                        item?.sku
                                      ) && hydrponicType === "hydroponicsOnly"
                                        ? item?.countGrow || 0
                                        : item?.count || 0}
                                      {item?.unit || "N/A"}
                                      <span>
                                        {item?.countKg
                                          ? ` / ${item?.countKg}kg`
                                          : ""}
                                      </span>
                                    </b>
                                  </span>
                                  <hr className="m-1" />
                                  <b>
                                    In Stock :{" "}
                                    {Number(
                                      currentInventoryData.find(
                                        (inv) => inv.sku === item.sku
                                      )?.inStock || 0
                                    )}
                                  </b>
                                  <hr className="m-1" />
                                  <b>Cost/Unit : {roundOffCost(item?.cost)}</b>
                                  <hr className="m-1" />
                                  <b>
                                    Total :
                                    {roundOffCost(
                                      getPrice(
                                        item?.count,
                                        item?.cost,
                                        item?.weight,
                                        item?.proUnit
                                      )
                                    )}
                                  </b>
                                </td>
                                <td className="w-25">
                                  {item?.attachPhoto ? (
                                    <LazyImageComponent
                                      width="100%"
                                      src={item?.attachPhoto}
                                      alt={`attachPhoto-${index + 1}`}
                                    />
                                  ) : (
                                    "N/A"
                                  )}
                                </td>
                              </tr>
                            );
                          })}

                        {/* ✅ Fixed Total Row */}
                        <tr>
                          <td colSpan="3" className="text-end fw-bold fs-4">
                            Total Cost:
                          </td>
                          <td className="fw-bold fs-4">
                            {roundOffCost(
                              materialData?.reduce(
                                (acc, item) =>
                                  acc +
                                  (getPrice(
                                    item?.count,
                                    item?.cost,
                                    item?.weight,
                                    item?.proUnit
                                  ) || 0),
                                0
                              )
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              <hr />
              <h2>Line Items</h2>
              <hr />
              <div className="table-responsive">
                {data && (
                  <table className="table table-vcenter">
                    <thead>
                      <tr>
                        <th>PARTICULARS</th>
                        <th>Item Unit</th>
                        <th>Item Quantity</th>
                        <th>Loading photo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.lineItems?.map((lineItem, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              {(lineItem?.particulars || "N/A").toUpperCase()}
                              {lineItem?.hsn && <b> ({lineItem?.hsn})</b>}
                            </td>
                            <td>
                              {(lineItem?.itemUnit || "N/A").toUpperCase()}
                            </td>
                            <td>
                              {(lineItem?.itemQuantity || "N/A").toUpperCase()}
                            </td>
                            <td className="w-25">
                              {lineItem?.uploadPhoto ? (
                                <LazyImageComponent
                                  width="100%"
                                  src={lineItem?.uploadPhoto}
                                  alt={`uploadPhoto-${index + 1}`}
                                />
                              ) : (
                                "N/A"
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <button
                  className="btn mx-1 mt-2 btn-primary"
                  onClick={handelDCAproval}
                  disabled={data?.isApproved}
                >
                  <BsCheck2Square className="fs-2 me-2" /> APPROVE DC
                </button>
                <SimpleButton
                  buttonText={"generate pdf"}
                  href={`/delivery-challan/preview/${id}`}
                />
                <button
                  disabled={data?.isApproved}
                  onClick={() => {
                    navigate(`/delivery-challan/edit/${id}`);
                  }}
                  className="btn mx-1 mt-2 btn-primary"
                >
                  {" "}
                  <BsCheck2Square className="fs-2 me-2" />
                  EDIT DELIVERY CHALLAN
                </button>
                <SimpleButton buttonText="Duplicate" onClick={duplicateDC} />

                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewDeliveryChallan;
